export default __webpack_public_path__ + "static/media/emailTemplateIcon.8ba13f0f.svg";